module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#c01"
    }
  }, [_vm._v("How to use this book")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/c01#c01a"
    }
  }, [_vm._v("The Building Blocks")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appliquéd Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c04#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basket Weave")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c05#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain-Pieced strips")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chevrons")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crazy Triangles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cross Block")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c09#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Half-Square Triangles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Log Cabin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pieced Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c12#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portholes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c13#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quarter Circles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c14#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("String Block")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c15#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X Block")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quilts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoe Boxes Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farm Buildings Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c23#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seed Tray Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c26#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feathers Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c29#c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bricks and Fences Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c32#c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden Wall Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c35#c35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesh Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c38#c38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pavement Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c41#c41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c44#c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railings Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c47#c47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rope Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c50#c50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building Blocks Quilt")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c52#c52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/sup#sup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ack#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/cop#cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0